<template>
  <div class="v-atlas-raumplanung-attribute-info">
    <div v-if="metadata" class="v-atlas-raumplanung-attribute-info__content">



      <section class="v-atlas-raumplanung-attribute-info__section">
        <h3>Vollständige Bezeichnung:</h3>
        <p><em>{{ metadata.label }}</em></p>
      </section>


      <section v-if="metadata.description" class="v-atlas-raumplanung-attribute-info__section">
        <h3>Beschreibung:</h3>
        <p>{{ metadata.description }}</p>
      </section>


      <section v-if="coveredLevels.length > 0" class="v-atlas-raumplanung-attribute-info__section">
        <h3>Verfügbar für administrative Ebenen:</h3>
        <ul class="c-chip-list">
          <li v-for="level of coveredLevels">{{ level }}</li>
        </ul>
      </section>

      <section v-if="metadata.tags && metadata.tags.length > 0" class="v-atlas-raumplanung-attribute-info__section">
        <h3>Kategorien:</h3>
        <ul class="c-chip-list">
          <li v-for="tag of metadata.tags">{{ tag }}</li>
        </ul>
      </section>

      <section class="v-atlas-raumplanung-attribute-info__section">
        <h3>Quellen:</h3>

        <ul v-if="metadata.sources instanceof Array && metadata.sources.length > 0">
          <li v-for="source of metadata.sources">
            {{ source }}
          </li>
        </ul>
        <p v-else>- Keine Quellen angegeben -</p>

      </section>

    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { RaumplanungAttributeMetadataListEntry, regionalDepthToSpatialUnitTypes } from "atlas-shared";

const props = defineProps<{
  metadata: RaumplanungAttributeMetadataListEntry | null
}>()

/** The administrative levels this dataset is available for, as human-readable labels. */
const coveredLevels = computed(() => {
  const codes = props.metadata?.regionalDepth ?? [];
  return regionalDepthToSpatialUnitTypes(codes);
})
</script>
